module.exports = __webpack_public_path__ + "static/keytruda-lenvima-logo-mobile-748e7e05b02be254457e9dbd54c1966b.png";